import { ChangeDetectionStrategy, Component, computed, effect, inject, input, model, output } from '@angular/core';
import { GuidelineService } from 'shared/domain';

import { ComponentExpandStrategy, ComponentListWidget, ComponentWidget } from '@treetop/shared/model';

import { EditComponentListWidgetService } from '../../../../../guideline-edit/edit-widgets/edit-component-list-widget/edit-component-list-widget.service';
import { ICompareWidgetComponent } from '../../widget-component.interface';
import { CompareComponentWidgetComponent } from './component/compare-component-widget.component';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-compare-component-list-widget',
  templateUrl: './compare-component-list-widget.component.html',
  styleUrls: ['./compare-component-list-widget.component.scss'],
  imports: [CompareComponentWidgetComponent],
  providers: [EditComponentListWidgetService],
})
export class CompareComponentListWidgetComponent implements ICompareWidgetComponent<ComponentListWidget> {
  private guidelineService = inject(GuidelineService);
  private service = inject(EditComponentListWidgetService);

  public widget = input.required<ComponentListWidget>();
  protected componentWidgets = computed(() => {
    return this.widget().widgetIds?.map((widgetId) => this.guidelineService.getWidget<ComponentWidget>(widgetId));
  });

  public isEditMode = model(false);
  public isCompareMode = input(false);
  public mergeConflictStatus = input<'conflict' | 'resolved' | undefined>();
  public expandStrategy = input<ComponentExpandStrategy | null>(null);

  public allowEditTags = input<boolean>(false);

  public resolveMergeConflict = output();
  public unresolveMergeConflict = output();

  constructor() {
    effect(() => {
      this.service.setWidget(this.widget());
    });
  }
}
